import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import "./ViewAssessmentResponse.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faPencil,
  faXmark,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import VideoPlayer from "../../../_uiComponents/VideoPlayerBasic";
import StarRatings from "react-star-ratings";
import useViewAssessmentResponse from "./useViewAssessmentResponse";
import MainLayout from "../../../_components/Common/MainLayout";
import { ASSESSMENT_ASSIGN_STATUS } from "../../../_constants/AssessmentConst";

function ViewAssessmentResponse(props) {
  const {
    user,
    assessementDetails,
    candidateResponse,
    question,
    loading,
    isEditRemark,
    questionIndex,
    shortlistRejectType,
    isAcceptReviewModal,
    isShortlistRejectModal,
    candidateResponseLoading,
    onAcceptReviewKit,
    shortlistRejectClick,
    handleAcceptReviewModal,
    handleShortlistRejectModal,
    onQuestionViewClick,
    onNextPrevClick,
    acceptReviewClick,
    onNavigateBack,
    onRemarkInputBlur,
    onEditRemark,
    onQuestionRatingChange,
  } = useViewAssessmentResponse(props);

  return (
    <MainLayout pageName={"View Assessment Videos"}>
      <div className="view-assessment-video">
        {loading ? (
          <div className="p-5 text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div>
            {Array.isArray(candidateResponse) &&
            candidateResponse.length > 0 ? (
              <div className="view-interview-wrapper">
                <div className="container">
                  <div className="player-wrapper pb-2">
                    <div className="row flex-grow-1">
                      {question && (
                        <div className="interview-video col-lg-8">
                          <div className="border bg-white border-radius-10 p-3 shadow-2 mt-3 mb-md-4">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap">
                              <div className="d-flex align-items-center">
                                <FontAwesomeIcon
                                  onClick={onNavigateBack}
                                  className="text-grey-4 mr-3 cursor-pointer h2"
                                  icon={faAngleLeft}
                                />
                                <div className="d-flex align-items-center">
                                  <img
                                    src={"/assets/images/user.png"}
                                    alt="candidate"
                                    style={{ width: "50px", height: "50px" }}
                                    className="border-radius-10"
                                  />
                                  <div className="info mx-3 text-capitalize">
                                    <h3>
                                      {
                                        assessementDetails?.candidate_id
                                          ?.full_name
                                      }
                                    </h3>
                                    <p className="text-grey-4 fs-14 mb-0">
                                      {assessementDetails?.assessment_id?.title}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex align-items-start justify-content-between">
                                {user?.user?.id ===
                                  assessementDetails?.reviewed_by_id?.id && (
                                  <div className="d-flex">
                                    {assessementDetails?.status ===
                                      ASSESSMENT_ASSIGN_STATUS.rejected ||
                                    assessementDetails?.status ===
                                      ASSESSMENT_ASSIGN_STATUS.shortlisted ? null : (
                                      <button
                                        className="btn btn-outline-danger d-flex align-items-center"
                                        onClick={() =>
                                          handleShortlistRejectModal("rejected")
                                        }
                                      >
                                        <FontAwesomeIcon
                                          icon={faXmark}
                                          className="font-weight-medium mr-md-2 p-2 p-md-0"
                                        />{" "}
                                        <span className="d-none d-md-block">
                                          Reject
                                        </span>
                                      </button>
                                    )}

                                    {assessementDetails?.status ===
                                      ASSESSMENT_ASSIGN_STATUS.rejected ||
                                    assessementDetails?.status ===
                                      ASSESSMENT_ASSIGN_STATUS.shortlisted ? null : (
                                      <button
                                        className={`btn btn-outline-success ml-3 d-flex align-items-center`}
                                        onClick={() =>
                                          handleShortlistRejectModal(
                                            "shortlisted"
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon
                                          icon={faCheck}
                                          className="font-weight-medium mr-md-2 p-2 p-md-0"
                                        />
                                        <span className="d-none d-md-block">
                                          Shortlist
                                        </span>{" "}
                                      </button>
                                    )}
                                  </div>
                                )}

                                {(assessementDetails?.status ===
                                  ASSESSMENT_ASSIGN_STATUS.rejected ||
                                  assessementDetails?.status ===
                                    ASSESSMENT_ASSIGN_STATUS.shortlisted) && (
                                  <div className="d-flex">
                                    <button
                                      className={`btn ${
                                        assessementDetails?.status ===
                                        ASSESSMENT_ASSIGN_STATUS.rejected
                                          ? "btn-danger"
                                          : "btn-success"
                                      } d-flex align-items-center`}
                                    >
                                      <FontAwesomeIcon
                                        icon={
                                          assessementDetails?.status ===
                                          ASSESSMENT_ASSIGN_STATUS.rejected
                                            ? faXmark
                                            : faCheck
                                        }
                                        className="font-weight-medium mr-md-2 p-2 p-md-0"
                                      />{" "}
                                      <span className="d-none text-capitalize d-md-block">
                                        {assessementDetails?.status}{" "}
                                        {assessementDetails?.reviewed_by_id
                                          ?.id === user?.user?.id
                                          ? "by You"
                                          : `by ${assessementDetails?.reviewed_by_id?.full_name}`}
                                      </span>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>

                            {candidateResponseLoading ? (
                              <div className="p-4 text-center">
                                <Spinner />
                              </div>
                            ) : (
                              <>
                                <div className="mt-3 border-top py-3 fs-14 d-flex align-items-center flex-wrap justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <div className="bg-grey p-1 border rounded-pill mr-3">
                                      <p className="text-primary rounded-pill mb-0 border px-2 py-1 bg-light-blue border-primary text-capitalize d-inline mr-2">
                                        {question?.question_id?.topic_id?.topic_name}
                                      </p>
                                     
                                      <span className="d-inline-block rounded-pill py-1 px-2 text-capitalize">
                                        {question?.question_id?.skill_id?.skill}
                                      </span>
                                    </div>
                                    <div className="d-none d-md-block">
                                      <StarRatings
                                        rating={
                                          question
                                            ?.candidate_response_rating_id[0] &&
                                          question
                                            .candidate_response_rating_id[0]
                                            ?.rating_value === null
                                            ? 0
                                            : question
                                                ?.candidate_response_rating_id[0] &&
                                              question
                                                .candidate_response_rating_id[0]
                                                ?.rating_value
                                        }
                                        starRatedColor="#FFCC2A"
                                        changeRating={(e) =>
                                          onQuestionRatingChange(
                                            e,
                                            question
                                              .candidate_response_rating_id[0]
                                              ?.id
                                          )
                                        }
                                        numberOfStars={5}
                                        name="rating"
                                        starDimension="24"
                                        starHoverColor="#FCDDB0"
                                        starSpacing="2px"
                                      />
                                    </div>
                                  </div>
                                  {assessementDetails?.reviewed_by_id && (
                                    <p className="mb-0 text-capitalize d-flex">
                                      <h3 className="font-weight-medium">
                                        Reviewed By:
                                      </h3>{" "}
                                      <span className="ml-2">
                                        {assessementDetails?.assigned_by_id ===
                                        assessementDetails?.reviewed_by_id
                                          ? "You"
                                          : assessementDetails?.reviewed_by_id &&
                                            assessementDetails.reviewed_by_id
                                              ?.full_name}
                                      </span>
                                    </p>
                                  )}
                                </div>
                                <div className="question-wrapper d-flex  justify-content-center text-grey-1">
                                  <span className="select form-group w-100">
                                    <select
                                      className="form-control bg-transparent border-radius-10"
                                      name="questions"
                                      value={
                                        question?.question_id?.question_text || ""
                                      }
                                      onChange={(e) => onQuestionViewClick(e)}
                                    >
                                      {candidateResponse &&
                                        candidateResponse.map((item, index) => (
                                          <option
                                            key={item?.question_id?.id}
                                            value={item?.question_id?.question_text}
                                          >
                                            {item?.question_id?.question_text}
                                          </option>
                                        ))}
                                    </select>
                                  </span>
                                </div>

                                <div className="video-wrapper border-radius-10">
                                  <VideoPlayer
                                    playbackId={question?.video_asset_id}
                                    isAutoPlay={true}
                                    height={400}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}

                      {question && (
                        <div className="col-lg-4 mt-3 mb-4 mb-md-4">
                          <div className="border bg-white border-radius-10 p-3 shadow-2 h-100 mb-md-4 position-relative">
                            <div className="question-panel position-relative">
                              <div className="form-group mt-2 w-100">
                                <label
                                  htmlFor=""
                                  className="mb-2 font-weight-medium text-black"
                                >
                                  Assessment Review Remark
                                </label>

                                {user?.user?.id !==
                                assessementDetails?.reviewed_by_id?.id ? (
                                  <p
                                    className={`${
                                      assessementDetails?.remark_by_reviewee
                                        ? "form-control"
                                        : ""
                                    } fs-smallest`}
                                  >
                                    {assessementDetails?.remark_by_reviewee}
                                  </p>
                                ) : assessementDetails?.remark_by_reviewee ? (
                                  <div className="my-2 d-flex">
                                    {!isEditRemark && (
                                      <>
                                        <span className="form-control flex-grow-1">
                                          {
                                            assessementDetails?.remark_by_reviewee
                                          }
                                        </span>

                                        <FontAwesomeIcon
                                          icon={
                                            isEditRemark ? faXmark : faPencil
                                          }
                                          className={`text-success border border-success cursor-pointer  p-1 rounded ml-2`}
                                          onClick={() => onEditRemark()}
                                        />
                                      </>
                                    )}
                                  </div>
                                ) : null}

                                {assessementDetails?.reviewed_by_id ? (
                                  <>
                                    {!assessementDetails?.remark_by_reviewee ||
                                    isEditRemark ? (
                                      <div className="mb-4">
                                        <textarea
                                          className="form-control h-auto  border-radius-10 "
                                          placeholder="Add Remark Here"
                                          rows="5"
                                          onBlur={(e) => onRemarkInputBlur(e)}
                                          name="remark_by_reviewee"
                                          defaultValue={
                                            assessementDetails?.remark_by_reviewee
                                          }
                                        ></textarea>

                                        {assessementDetails?.remark_by_reviewee ? (
                                          <div className="d-flex justify-content-end mt-2">
                                            <button
                                              className="btn btn-danger py-1 ml-auto px-2"
                                              onClick={() => onEditRemark()}
                                            >
                                              Cancel
                                            </button>{" "}
                                          </div>
                                        ) : null}
                                      </div>
                                    ) : null}
                                  </>
                                ) : (
                                  <div>
                                    <p className="fs-smallest">
                                      Accept kit to review to put your remark
                                    </p>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => onAcceptReviewKit()}
                                    >
                                      Accept
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            <button
                              className="next-btn btn btn-primary ml-3 position-absolute d-none d-md-block"
                              disabled={
                                questionIndex === candidateResponse.length - 1
                              }
                              onClick={() =>
                                onNextPrevClick(question?.id, "add")
                              }
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bottom d-flex d-md-none align-items-center justify-content-between bg-white border-top p-3 position-fixed w-100">
                  <StarRatings
                    rating={
                      question?.rating && question.rating?.rating === null
                        ? 0
                        : question?.rating && question.rating?.rating
                    }
                    starRatedColor="#FFCC2A"
                    changeRating={(e) => onQuestionRatingChange(e)}
                    numberOfStars={5}
                    name="rating"
                    starDimension="24"
                    starHoverColor="#FCDDB0"
                    starSpacing="2px"
                  />

                  <button
                    className="btn btn-primary ml-3"
                    disabled={questionIndex === candidateResponse.length - 1}
                    onClick={() => onNextPrevClick(question?.id, "add")}
                  >
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <div className="view-interview-wrapper">
                <div className="container">
                  <div className="player-wrapper pb-2">
                    <div className="row flex-grow-1">
                      <div className="interview-video col-lg-12">
                        <div className="border bg-white border-radius-10 p-3 shadow-2 mt-3 mb-md-4">
                          <div className="d-flex justify-content-between border-bottom pb-3 flex-wrap flex-md-nowrap">
                            <div className="d-flex align-items-center">
                              <FontAwesomeIcon
                                onClick={onNavigateBack}
                                className="text-grey-4 mr-3 cursor-pointer h2"
                                icon={faAngleLeft}
                              />
                              <div className="d-flex align-items-center">
                                <img
                                  src={"/assets/images/user.png"}
                                  alt="candidate"
                                  style={{ width: "50px", height: "50px" }}
                                  className="border-radius-10"
                                />
                                <div className="info mx-3 text-capitalize">
                                  <h3>
                                    {assessementDetails?.assessment_id?.title}
                                  </h3>
                                  <p className="text-grey-4 fs-14 mb-0">
                                    {
                                      assessementDetails?.candidate_id
                                        ?.full_name
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="view-interview-wrapper text-center p-4">
                            <img src="/assets/images/warning.png" alt="info" />
                            <p className="text-danger  ">
                              {
                                "Candidate has not taken the assessment kit yet!"
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <Modal
        show={isAcceptReviewModal}
        centered
        size="md"
        onHide={() => handleAcceptReviewModal()}
        className="common-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Accept kit to review</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-white d-flex align-items-center justify-content-center flex-column">
          <h4>
            Please make sure to complete your assessment review once you accept
            it.
          </h4>

          <div className="action mt-4">
            <button
              className="btn btn-primary px-5"
              onClick={() => acceptReviewClick()}
            >
              Confirm
            </button>

            <button
              className="btn btn-dark ml-4 px-5"
              onClick={() => handleAcceptReviewModal()}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={isShortlistRejectModal}
        centered
        size="md"
        onHide={() => handleShortlistRejectModal()}
        className="common-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Remarks to {shortlistRejectType}.</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-white">
          <h3 className="mb-3">Update Assessment Kit Remark:</h3>

          <textarea
            className="form-control h-auto bg-white border-radius-10"
            placeholder="Add remark here"
            rows="5"
            onBlur={(e) => onRemarkInputBlur(e)}
            name="remark_by_reviewee"
            defaultValue={assessementDetails?.remark_by_reviewee}
          ></textarea>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary px-5"
            onClick={() => shortlistRejectClick()}
          >
            Confirm
          </button>

          <button
            className="btn btn-dark ml-4 px-5"
            onClick={() => handleShortlistRejectModal()}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </MainLayout>
  );
}
export default ViewAssessmentResponse;
